import { router } from "@inertiajs/react"
import * as React from "react"
import { toast } from "sonner"

import { Button } from "@/components/ui/button"
import { userPath } from "@/routes"

// Muestra un toast de insignia desbloqueada
export function showBadgeToast(
  badge: { name: string; emoji?: string; reason?: string },
  userId?: number,
) {
  toast(
    React.createElement(
      "div",
      { className: "flex flex-col gap-2" },
      React.createElement(
        "div",
        { className: "text-lg font-semibold" },
        "🎉 ¡Nueva insignia!",
      ),
      React.createElement(
        "div",
        { className: "flex items-center gap-3" },
        React.createElement(
          "div",
          { className: "text-2xl", "aria-hidden": true },
          badge.emoji ?? "🏅",
        ),
        React.createElement(
          "div",
          null,
          React.createElement("div", { className: "font-medium" }, badge.name),
          badge.reason
            ? React.createElement(
                "div",
                { className: "text-sm text-muted-foreground" },
                badge.reason,
              )
            : null,
        ),
      ),
      userId
        ? React.createElement(
            "div",
            { className: "pt-1" },
            React.createElement(
              Button,
              {
                size: "sm",
                variant: "secondary",
                onClick: () => router.visit(userPath(userId)),
              },
              "Ver mis insignias",
            ),
          )
        : null,
    ),
  )
}

export function showPointsToast(payload: { points: number; reason?: string }) {
  toast(
    React.createElement(
      "div",
      { className: "flex items-start gap-3" },
      React.createElement(
        "div",
        { className: "text-xl", "aria-hidden": true },
        "⭐",
      ),
      React.createElement(
        "div",
        null,
        React.createElement(
          "div",
          { className: "font-semibold" },
          `+${payload.points} puntos`,
        ),
        payload.reason
          ? React.createElement(
              "div",
              { className: "text-sm text-muted-foreground" },
              payload.reason,
            )
          : null,
      ),
    ),
  )
}

export function showChallengeToast(payload: {
  title: string
  description: string
  points: number
  icon?: string
}) {
  toast(
    React.createElement(
      "div",
      { className: "flex items-start gap-3" },
      React.createElement(
        "div",
        { className: "text-2xl", "aria-hidden": true },
        payload.icon ?? "🎯",
      ),
      React.createElement(
        "div",
        null,
        React.createElement(
          "div",
          { className: "font-semibold" },
          payload.title,
        ),
        React.createElement(
          "div",
          { className: "text-sm text-muted-foreground" },
          payload.description,
        ),
        React.createElement(
          "div",
          { className: "text-sm text-green-600 font-medium mt-1" },
          `+${payload.points} puntos bonus`,
        ),
      ),
    ),
  )
}
